import React, { useMemo } from 'react'
import Seo from '../Seo'

const env = (typeof process !== 'undefined' && process.env) || {}

const DEFAULTS = {
  embedUrl: 'https://app.leanit101.com/benjamin',
  embedToken:
    'eyJvcmdhbml6YXRpb25JZCI6MzAsImFnZW50U2x1ZyI6ImNlbnRyYWwtZW5lcmdldGljYS1zYWxlcy1hc3Npc3RhbnQiLCJ0ZW5hbnRTbHVnIjoiY2VudHJhbC1lbmVyZy10aWNhIiwiYXNzaXN0YW50TmFtZSI6IkFnZW50ZSBkZSBWZW5kYXMgQ2VudHJhbCBFbmVyZ8OpdGljYSIsIm1ldGFkYXRhIjp7ImNoYW5uZWxEZWZhdWx0Ijoid2ViX2VtYmVkIn19.74c815ad8074957ffedb5655fd2eb8c79c6296e1a53fcb62350d5e3de2f2fb79',
  agentSlug: 'central-energetica-sales-assistant',
  tenantSlug: 'central-energ-tica',
  organizationId: '30',
  assistantName: 'Agente de Vendas Central Energética',
  channel: 'web_embed',
  utmSource: 'leanit101.com',
  utmCampaign: 'central-energetica-sales-poc',
}

const CentralEnergeticaSalesPage = () => {
  const queryParams = useMemo(() => {
    if (typeof window === 'undefined') return new URLSearchParams('')
    return new URLSearchParams(window.location.search || '')
  }, [])

  const embedToken =
    queryParams.get('token') ||
    env.REACT_APP_CENTRAL_ENERGETICA_EMBED_TOKEN ||
    DEFAULTS.embedToken

  const agentSlug =
    queryParams.get('agentSlug') ||
    env.REACT_APP_CENTRAL_ENERGETICA_AGENT_SLUG ||
    DEFAULTS.agentSlug

  const tenantSlug =
    (
      queryParams.get('tenantSlug') ||
      env.REACT_APP_CENTRAL_ENERGETICA_TENANT_SLUG ||
      DEFAULTS.tenantSlug
    )
      .toString()
      .trim()
      .toLowerCase()

  const organizationId =
    queryParams.get('organizationId') ||
    env.REACT_APP_CENTRAL_ENERGETICA_ORGANIZATION_ID ||
    DEFAULTS.organizationId

  const assistantName =
    queryParams.get('assistantName') ||
    env.REACT_APP_CENTRAL_ENERGETICA_ASSISTANT_NAME ||
    DEFAULTS.assistantName

  const channel = queryParams.get('channel') || DEFAULTS.channel
  const utmSource = queryParams.get('utm_source') || DEFAULTS.utmSource
  const utmCampaign = queryParams.get('utm_campaign') || DEFAULTS.utmCampaign

  const iframeSrc = useMemo(() => {
    const params = new URLSearchParams()
    if (embedToken) params.set('token', embedToken)
    params.set('agentSlug', agentSlug)
    params.set('tenantSlug', tenantSlug)
    params.set('organizationId', organizationId)
    params.set('assistantName', assistantName)
    params.set('channel', channel)
    params.set('locale', 'pt-BR')
    if (utmSource) params.set('utm_source', utmSource)
    if (utmCampaign) params.set('utm_campaign', utmCampaign)
    params.set('meta.source', 'central-energetica-sales-poc')
    params.set('meta.partner', 'central-energetica')

    const baseUrl =
      env.REACT_APP_CENTRAL_ENERGETICA_EMBED_URL || DEFAULTS.embedUrl
    return `${baseUrl}?${params.toString()}`
  }, [
    agentSlug,
    assistantName,
    channel,
    embedToken,
    organizationId,
    tenantSlug,
    utmCampaign,
    utmSource,
  ])

  return (
    <section className="relative flex flex-col w-full min-h-screen overflow-hidden bg-[#060912] text-white">
      <Seo
        title="Central Energética | Agente de Vendas"
        description="POC privada para validar o agente comercial da Central Energética."
        path="/central-energetica-sales"
        noindex
      />
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0c1224] via-[#060912] to-[#060912]" />
        <div
          className="absolute -top-28 left-[14%] h-[620px] w-[620px] rounded-full opacity-28"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(59,130,246,0.28) 0%, rgba(59,130,246,0) 68%)',
            filter: 'blur(56px)',
          }}
        />
        <div
          className="absolute bottom-[-220px] right-[-120px] h-[560px] w-[560px] rounded-full opacity-26"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(34,197,94,0.22) 0%, rgba(34,197,94,0) 66%)',
            filter: 'blur(48px)',
          }}
        />
        <div
          className="absolute inset-0 opacity-[0.07]"
          style={{
            backgroundImage:
              'linear-gradient(to right, rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.06) 1px, transparent 1px)',
            backgroundSize: '28px 28px',
          }}
        />
      </div>

      <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 px-4 py-12 md:py-16">
        <header className="space-y-4 text-center">
          <p className="text-xs uppercase tracking-[0.42em] text-sky-200/70">
            Central Energética
          </p>
          <h1 className="text-3xl font-semibold md:text-5xl">
            Otávio • triagem comercial para redução de custo de energia
          </h1>
          <p className="mx-auto max-w-3xl text-base text-slate-200 md:text-lg">
            Página de POC para validar o agente que faz a triagem inicial de
            empresas interessadas em reduzir gasto com energia, entender
            créditos em fatura, avaliar Mercado Livre ou encaminhar casos mais
            técnicos para a próxima etapa.
          </p>
        </header>

        <div className="grid gap-6 lg:grid-cols-[1.15fr_minmax(320px,0.85fr)]">
          <div className="w-full overflow-hidden rounded-[28px] border border-sky-200/10 bg-slate-900/55 shadow-2xl">
            <div className="border-b border-white/8 px-5 py-4">
              <div className="text-[11px] uppercase tracking-[0.34em] text-sky-200/68">
                Conversa ao vivo
              </div>
              <div className="mt-2 text-sm text-slate-300">
                Fluxo em português voltado para qualificação inicial, coleta de
                contexto da empresa, leitura do perfil de consumo e avanço para
                reunião quando houver sinal real de fit.
              </div>
            </div>
            <div className="relative h-[560px] w-full md:h-[660px]">
              <iframe
                title="Agente de Vendas Central Energética"
                src={iframeSrc}
                allow="clipboard-read; clipboard-write"
                className="absolute inset-0 h-full w-full"
                style={{ background: 'transparent', border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          <div className="grid content-start gap-4">
            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-sky-200/72">
                Objetivo da POC
              </div>
              <h2 className="mt-3 text-xl font-semibold">
                Identificar fit comercial com rapidez e clareza
              </h2>
              <p className="mt-3 text-sm leading-6 text-slate-200">
                O Otávio foi configurado para conduzir a primeira triagem de
                empresas, entender o tipo de unidade, estado, conta média,
                quantidade de unidades e sinalizar se o caso parece mais aderente
                a créditos de energia, Mercado Livre ou suporte técnico.
              </p>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-sky-200/72">
                O que observar
              </div>
              <ul className="mt-3 space-y-3 text-sm leading-6 text-slate-200">
                <li>Se o agente soa humano, consultivo e direto, sem parecer robótico.</li>
                <li>Se ele coleta rápido os dados mínimos de negócio sem travar a conversa.</li>
                <li>Se ele diferencia bem créditos, Mercado Livre e temas técnicos.</li>
                <li>Se ele leva casos qualificados para reunião sem prometer economia cedo demais.</li>
              </ul>
            </div>

            <div className="rounded-2xl border border-emerald-300/20 bg-[#0d1322] p-5">
              <div className="text-[11px] uppercase tracking-[0.3em] text-emerald-200/78">
                Compartilhamento
              </div>
              <p className="mt-3 text-sm leading-6 text-slate-200">
                Use este link com o cliente para validação da POC:
              </p>
              <code className="mt-3 block break-all text-xs text-emerald-200 md:text-sm">
                https://leanit101.com/central-energetica-sales
              </code>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-sky-200/72">
                Rastreio
              </div>
              <p className="mt-3 text-sm leading-6 text-slate-200">
                Esta página envia o embed com <strong>organizationId 30</strong>,
                locale <strong>pt-BR</strong> e metadados específicos da POC da
                Central Energética, pensada para validação comercial com leads
                empresariais.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CentralEnergeticaSalesPage
